<template>
  <div class="caileFerate">
    <h1>Caile Ferate, Eisenbahn</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_1kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_1.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_2kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_2.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_3kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_3.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_4kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_4.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_5kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_5.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_6kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_6.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_7kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_7.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_8kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_8.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_9kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_9.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_akl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_a.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_bkl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_b.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_ckl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_c.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_dkl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_d.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_ekl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_e.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Mus_fkl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_f.jpg', $event)">
				<br>Reschitza, Reşiţa: Eisenbahnmuseum, muzeul de caile ferate
      </div>

      <div class="foto">
        <img src="../assets/fotos/carp_4kl.jpg" width="125" border="0" height="110" alt="Carpaţi, Karpaten"
        @click="callImageClick('Carpaţi, Karpaten', 'carp_4.jpg', $event)">
				<br>Carpaţi, Karpaten
      </div>
      <div class="foto">
        <img src="../assets/fotos/bana_2kl.jpg" width="125" border="0" height="110" alt="Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung"
        @click="callImageClick('Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung', 'bana_2.jpg', $event)">
						<br>Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung
      </div>
      <div class="foto">
        <img src="../assets/fotos/klop_1kl.jpg" width="125" border="0" height="110" alt="Klopodia, Clopodia: Bahnhof, gara"
        @click="callImageClick('Klopodia, Clopodia im Banat: Bahnhof, gara', 'klop_1.jpg', $event)">
        <br>Klopodia, Clopodia im Banat: Bahnhof, gara
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_4kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_4.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_8kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_8.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/mara_1kl.jpg" width="125" border="0" height="110" alt="Maramureş, Maramuresch:  - Craciuneşti - Weihnachtsdorf"
        @click="callImageClick('Maramureş, Maramuresch:  - Craciuneşti - Weihnachtsdorf', 'mara_1.jpg', $event)">
        <br>Maramureş, Maramuresch: Craciuneşti - Weihnachtsdorf
			</div>
      <div class="foto">
				<img src="../assets/fotos/mara_2kl.jpg" width="125" height="110" border="0" alt="Maramureş, Maramuresch: links Breitspur, rechts Normalspur"
        @click="callImageClick('Maramureş, Maramuresch: links Breitspur, rechts Normalspur', 'mara_2.jpg', $event)">
        <br>Maramureş, Maramuresch: links Breitspur, rechts Normalspur
      </div>
      
      <div class="foto">
        <img src="../assets/fotos/Bahn_Kran_kl.jpg" width="125" height="110" border="0" alt="Kran" 
        @click="callImageClick('Kran', 'Bahn_Kran.jpg', $event)">
        <br>Kran
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahn_Schneeschleuder_1kl.jpg" width="125" height="110" border="0" alt="Schneeschleuder" 
        @click="callImageClick('Schneeschleuder', 'Bahn_Schneeschleuder_1.jpg', $event)">
        <br>Schneeschleuder
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahn_Schneeschleuder_2kl.jpg" width="125" height="110" border="0" alt="Schneeschleuder" 
        @click="callImageClick('Schneeschleuder', 'Bahn_Schneeschleuder_2.jpg', $event)">
        <br>Schneeschleuder
      </div>
      <div class="foto">
        <img src="../assets/fotos/BahnBruecke_kl.jpg" width="125" height="110" border="0" alt="Brücke bei Deva" 
        @click="callImageClick('Brücke bei Deva', 'BahnBruecke.jpg', $event)">
        <br>Brücke bei Deva
      </div>
      <div class="foto">
        <img src="../assets/fotos/Banat_Bf_kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara im Banat"
        @click="callImageClick('Bahnhof, gara im Banat', 'Bahnhof_Banat_Bf.jpg', $event)">
        <br>Bahnhof, gara im Banat
      </div>
      <div class="foto">
        <img src="../assets/fotos/Bahnhof_Sibiu_kl.jpg" width="125" height="110" border="0" alt="Bahnhof, gara: Hermannstadt, Sibiu"
        @click="callImageClick('Bahnhof, gara: Hermannstadt, Sibiu', 'Bahnhof_Sibiu.jpg', $event)">
        <br>Bahnhof, gara: Hermannstadt, Sibiu
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sib_Mus_1kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate', 'Sib_Mus_1.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sib_Mus_2kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate', 'Sib_Mus_2.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sib_Mus_3kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate', 'Res_Mus_3.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sib_Mus_4kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate', 'Sib_Mus_4.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sib_Mus_5kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate', 'Sib_Mus_5.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnmuseum, muzeul de caile ferate
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sibiu_Kran_kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Eisenbahnkran"
        @click="callImageClick('Hermannstadt, Sibiu: Eisenbahnkran', 'Sibiu_Kran.jpg', $event)">
				<br>Hermannstadt, Sibiu: Eisenbahnkran
      </div>
      <div class="foto">
        <img src="../assets/fotos/Sibiu_Mocanita_kl.jpg" width="125" border="0" height="110" alt="Hermannstadt, Sibiu: Schmalspurbahn nach Agneteln, mocaniţa spre Agnita"
        @click="callImageClick('Hermannstadt, Sibiu: Schmalspurbahn nach Agneteln, mocaniţa spre Agnita', 'Sibiu_Mocanita.jpg', $event)">
				<br>Hermannstadt, Sibiu: Schmalspurbahn nach Agneteln, mocaniţa spre Agnita
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>